import React from 'react';
import intl from 'react-intl-universal';
import useTheme from '../hooks/useTheme';
import './ResultBackBar.scss';

export default function ResultBackBar({ onBack }: { onBack: () => void }): JSX.Element {
  const { mainColor } = useTheme();
  return (
    <div className="result-back-bar">
      <button type="button" onClick={onBack} style={{ color: mainColor }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M20 12H4m7-7-7 7 7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span>{intl.get('Back Home')}</span>
      </button>
    </div>
  );
}
